<div class="container-xxl gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="row mb-8 mb-xl-0">
        <div class="col-12 col-lg-4 d-flex flex-column justify-content-center">
            <p class="mb-5 lh-29" [innerHtml]="'ABOUT_US.content_full_p2' | translate"></p>
            <p class="mb-5 lh-29" [innerHtml]="'ABOUT_US.content_full_p3' | translate"></p>
            <p class="mb-5 lh-29" [innerHtml]="'ABOUT_US.content_full_p4' | translate"></p>
        </div>
        <div class="col-12 col-lg-8">
            <div class="h-100 overflow-hidden">
                <img class="min-w-100 min-h-100 img-fluid item-md-center" src="/assets/images/building_big.png" alt="" />
            </div>
        </div>
    </div>
</div>
